import React from "react";
import { Avatar, Typography, Box } from "@mui/material";
import { HandHeart, UserCirclePlus, CalendarDots, ReadCvLogo } from "@phosphor-icons/react";
import getAvatarInitials from "utils/getAvatarInitials";

const formatText = (text) => {
  // Split by * and map through parts
  return text.split(/\*(.+?)\*/).map((part, index) => {
    // Every odd index is between ** and should be styled with bold
    if (index % 2 === 1) {
      return (
        <Box key={index} component="span" fontWeight={500}>
          {part}
        </Box>
      );
    }
    return (
      <Box key={index} component="span" color="text.secondary">
        {part}
      </Box>
    );
  });
};

export const getNotificationIcon = (notification) => {
  const metadata = notification.metadata || {};

  if (notification.type === "clinical") {
    switch (metadata.action) {
      case "client_assigned":
        return <UserCirclePlus size={20} weight="duotone" />;
      case "schedule_assessment":
      case "schedule_treatment_plan_review":
        return <CalendarDots size={20} weight="duotone" />;
      case "auth_submitted":
      case "auth_approved":
        return <HandHeart size={20} weight="duotone" />;
      case "upload_treatment_plan":
        return <ReadCvLogo size={20} weight="duotone" />;
    }
  }

  return (
    <Avatar src={metadata.image_url} sx={{ width: 32, height: 32, fontSize: 16 }}>
      {getAvatarInitials(metadata.sender_name)}
    </Avatar>
  );
};

export const getClinicalNotificationBody = (notification) => {
  const metadata = notification.metadata || {};

  switch (metadata.action) {
    case "client_assigned":
      return (
        <Typography variant="body2">
          {formatText(`*${metadata.client_name || "client"}* was added to your caseload`)}
        </Typography>
      );
    case "schedule_assessment":
      return (
        <Typography variant="body2">
          {formatText(
            `It's time to schedule *${metadata.client_name || "client"}'s assessment appointment*`
          )}
        </Typography>
      );
    case "schedule_treatment_plan_review":
      return (
        <Typography variant="body2">
          {formatText(
            `It's time to schedule *${metadata.client_name || "client"}'s* *Treatment Plan Review appointment* `
          )}
        </Typography>
      );
    case "auth_submitted":
      return (
        <Typography variant="body2">
          {formatText(
            `An *Insurance Authorization* has been submitted for *${metadata.client_name || "client"}*`
          )}
        </Typography>
      );
    case "auth_approved":
      return (
        <Typography variant="body2">
          {formatText(
            `An *Insurance Authorization* has been approved for *${metadata.client_name || "client"}*`
          )}
        </Typography>
      );
    case "upload_treatment_plan":
      return (
        <Typography variant="body2">
          {formatText(
            `Upload and submit *${metadata.client_name || "client"}'s Treatment Plan* to move forward with care.`
          )}
        </Typography>
      );
    default:
      return <Typography variant="body2">Unknown notification</Typography>;
  }
};
